/*
  Rollbar is attached to the window via separate script tag (served to document by rails).
  The import is used to get the TS type, and so the package can remain a dev dependency.
*/
/* eslint-disable import/no-extraneous-dependencies */
import * as RollbarType from 'rollbar'

const dispatchRollbarError = (...args: RollbarType.LogArgument[]) => {
  // @ts-ignore -- window global not typed yet
  const Rollbar: RollbarType = window?.Rollbar

  if (!Rollbar) return

  Rollbar.error(...args)
}

export { dispatchRollbarError }
